import gql from 'graphql-tag';

export const gqlGetQuery = gql`
  query getWastereceptionpointTransactionsView(
    $limit: Int
    $offset: Int
    $order: String
    $where: String
  ) {
    getWastereceptionpointTransactionsView(
      limit: $limit
      offset: $offset
      order: $order
      where: $where
    ) {
      data {
        transactionTable
        referenceId
        masterId
        transactionDate
        transactionCode
        transactionAa
        sourceSiteTable
        sourceSiteId
        sourceSiteCode
        sourceSiteName
        destinationSiteTable
        destinationSiteId
        destinationSiteCode
        destinationSiteName
        materialId
        materialName
        inputWeight
        outputWeight
        wasteTransactionTypeId
        wasteTransactionType {
          value
          name
          id
        }
      }
      recordCount
    }
  }
`;
